module.exports = __webpack_public_path__ + "assets/img/18_189.876c8ce5.jpg";